<template>
    <v-alert
        v-if="should_show_alert"
        type="info"
        color="primary"
        border="left"
        elevation="1"
        class="mb-4"
        colored-border
    >
        <template #prepend>
            <v-icon
                v-if="icon"
                class="d-none d-sm-inline-block"
                color="primary"
                size="32"
                aria-hidden="true"
            >
                {{ icon }}
            </v-icon>
            <span v-else></span>
        </template>

        <div
            class="d-flex justify-space-between flex-wrap flex-grow-1 gap-4 ml-3"
            :class="wrap_early ? 'flex-lg-nowrap' : 'flex-md-nowrap'"
        >
            <div class="flex-shrink-1">
                <slot name="title">
                    <h3
                        v-if="title"
                        class="text-h6 font-weight-bold mb-1"
                    >
                        {{ title }}
                    </h3>
                </slot>

                <slot name="default">
                    <p
                        v-if="message"
                        class="text-body-2 mb-0"
                    >
                        {{ message }}
                    </p>
                </slot>
            </div>

            <div
                class="d-flex align-center flex-wrap flex-sm-shrink-0 gap-4"
                style="flex-basis: 300px;"
            >
                <v-checkbox
                    v-model="dont_show_again"
                    :label="dismissal_message"
                    color="primary"
                    class="pt-0 mt-0"
                    hide-details
                    dense
                />
                <v-btn
                    color="primary"
                    variant="outlined"
                    size="small"
                    @click="dismissAlert"
                >
                    Got it
                </v-btn>
            </div>
        </div>
    </v-alert>
</template>

<script>
/**
 * An alert that can be dismissed and will not show again if the user checks "Don't show this again".
 * The dismissal state is stored in local storage under the provided storage_key.
*/

export default {
    name: 'LocalStorageAlert',

    props: {
        icon: {
            type: String,
            default: null
        },

        title: {
            type: String,
            default: '',
        },

        message: {
            type: String,
            default: ''
        },

        dismissal_message: {
            type: String,
            default: "Don't show this again"
        },

        storage_key: {
            type: String,
            required: true
        },

        /**
         * In lieu of container queries, which are not well-supported enough yet, this prop
         * can be set to true to make the alert wrap its contents sooner, for use in
         * narrower containers.
        */
        wrap_early: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            dont_show_again: false,
            should_show_alert: true
        }
    },

    mounted() {
        const dismissed = localStorage.getItem(this.storage_key)
        if (dismissed === 'true') {
            this.should_show_alert = false
        }
    },

    methods: {
        dismissAlert() {
            if (this.dont_show_again) {
                localStorage.setItem(this.storage_key, 'true')
            }

            this.should_show_alert = false
            this.$emit('dismissed', { dont_show_again: this.dont_show_again })
        }
    }
}
</script>

<style lang="scss" scoped></style>